import React from 'react'

const SecretPage = () => {  
   
    return (
        <div className="bg-white m-3 sm:m-4 md:m-6 mt-3">
            <div className="mx-auto">
                <h1 className="text-black text-2xl md:text-3xl font-bold mb-4 md:mb-8">Secrets Management</h1>
                <p className="text-gray-600 mb-4">
                    This page is under construction. Please check back later for updates.
                </p>
                <p className="text-gray-600 mb-4">
                    For now, you can manage your secrets using the CLI tool.
                </p>
            </div>
        </div>
    )
}

export default SecretPage